<template>
    <!-- contents -->
    <div id="contents">
        <div class="contents_wrap">
            <!-- contents_head -->
            <h2 class="pg_title">{{ pageTitle }}</h2>
            <skp-breadcrumbs @page-title="val => (pageTitle = val)" />
            <!-- //contents_head -->
            <div :style="{ display: mode === 'list' ? 'block' : 'none' }">
                <!-- srchTop_wrap -->
                <div class="srchTop_wrap">
                    <article class="srch_basic">
                        <div class="srch_grup">
                            <ul class="w100">
                                <li class="tit_200">{{ $t('FIELD.COUNTRY.NAME') }}</li>
                                <li data-input-type="text" class="w100-200">
                                    <fieldset class="ui_fieldset set_3">
                                        <div>
                                            <select
                                                class="slt_white w100"
                                                v-model="country1"
                                                @change="getCountryList2()"
                                                disabled
                                            >
                                                <option
                                                    v-for="item in countryList1"
                                                    :key="'countryList1' + item.code"
                                                    :value="item.code"
                                                >
                                                    {{ item.codeName }}
                                                </option>
                                            </select>
                                        </div>
                                        <div>
                                            <select
                                                class="slt_white w100"
                                                v-model="country2"
                                                @change="getCountryList3()"
                                                disabled
                                            >
                                                <option
                                                    v-for="item in countryList2"
                                                    :key="'countryList2' + item.code"
                                                    :value="item.code"
                                                >
                                                    {{ item.codeName }}
                                                </option>
                                            </select>
                                        </div>
                                        <div>
                                            <select class="slt_white w100" v-model="country3">
                                                <option value="">{{ $t('FIELD.FAST.DURATION.ALL') }}</option>
                                                <option
                                                    v-for="item in countryList3"
                                                    :key="'countryList3' + item.code"
                                                    :value="item.code"
                                                >
                                                    {{ item.codeName }}
                                                </option>
                                            </select>
                                        </div>
                                    </fieldset>
                                </li>
                            </ul>
                            <ul class="w50">
                                <li class="tit_200">
                                    {{ $t('FIELD.REQUEST.TYPE') }}
                                </li>
                                <li data-input-type="text" class="w100-200">
                                    <select class="slt_white w100p" v-model="requestType">
                                        <option value="">{{ $t('FIELD.FAST.DURATION.ALL') }}</option>
                                        <option
                                            v-for="item in requestTypeList"
                                            :key="'requestTypeList' + item.code"
                                            :value="item.code"
                                        >
                                            {{ item.codeName }}
                                        </option>
                                    </select>
                                </li>
                            </ul>
                            <ul class="w50">
                                <li class="tit_200">{{ $t('FIELD.APPROVAL.STATUS') }}</li>
                                <li data-input-type="text" class="w100-200">
                                    <select class="slt_white w100p" v-model="approvalStatus">
                                        <option value="">{{ $t('FIELD.FAST.DURATION.ALL') }}</option>
                                        <option
                                            v-for="item in approvalStatusList"
                                            :key="'approvalStatusList' + item.code"
                                            :value="item.code"
                                        >
                                            {{ item.codeName }}
                                        </option>
                                    </select>
                                </li>
                            </ul>
                            <ul class="w50">
                                <li class="tit_200">{{ $t('FIELD.GLOBAL.REQUEST.DATE') }}</li>
                                <li data-input-type="date" class="w100-200">
                                    <fieldset class="ui_fieldset">
                                        <span class="date-wrap">
                                            <label>
                                                <input
                                                    id="frDate"
                                                    type="text"
                                                    class="date_input w100p"
                                                    :placeholder="$t('FIELD.KNOWLEDGE.SEARCH.FROMDATE')"
                                                    readonly
                                                    maxlength="20"
                                                />
                                                <a href="javascript:" class="in_btn" id="icoFrDate">
                                                    <i class="ico_date"></i>
                                                    <span class="sr_only">{{ $t('FIELD.GLOBAL.DATE') }}</span>
                                                </a>
                                            </label>
                                            <div class="fr_datepicker" id="fr-picker-container" />
                                        </span>
                                        <em class="txt_space"></em>
                                        <span class="date-wrap">
                                            <label>
                                                <input
                                                    id="toDate"
                                                    type="text"
                                                    class="date_input w100p"
                                                    :placeholder="$t('FIELD.UNTIL.DATE')"
                                                    readonly
                                                    maxlength="20"
                                                />
                                                <a href="javascript:" class="in_btn" id="icoToDate">
                                                    <i class="ico_date"></i>
                                                    <span class="sr_only">{{ $t('FIELD.GLOBAL.DATE') }}</span>
                                                </a>
                                            </label>
                                            <div class="to_datepicker" id="to-picker-container" />
                                        </span>
                                    </fieldset>
                                </li>
                            </ul>
                        </div>
                        <div class="srch_grupR_bottom">
                            <span class="btn">
                                <a href="javascript:" class="btn_srch" @click="onSearch(1)">{{
                                    $t('BUTTON.GLOBAL.SEARCH')
                                }}</a>
                            </span>
                        </div>
                    </article>
                </div>
                <!-- Grid -->
                <div class="grid_wrap number-cell">
                    <!-- Count -->
                    <div class="grid_total">
                        {{ $t('TITLE.TOTAL.COUNT') }} : <em>{{ totalCount | numberFormat }}</em>
                    </div>
                    <toast-grid
                        :gridId="gridId"
                        :header="header"
                        :columns="columns"
                        :data="requestList"
                        :options="options"
                        :ref="gridId"
                        :key="gridKey"
                        :isTotalCount="false"
                        :click="contentClick"
                    />
                    <div class="paginate">
                        <sdl-pagination
                            align="center"
                            :current-page="currentPage"
                            :total-rows="totalCount"
                            :per-page="nRecordsPerPage"
                            @change="onSearch"
                        />
                    </div>
                </div>
            </div>
            <request-manager-detail v-if="mode == 'view'" :data="data"></request-manager-detail>
        </div>
    </div>
    <!-- contents -->
</template>

<script>
import $ from 'jquery';
import qs from 'query-string';
import Vue from 'vue';
import api from '@/service';
import axios from 'axios';
import store from '@/vuex/store';
import moment from 'moment';
import { EventBus } from '@/utils/EventBus';
import { SDLUtil, DateUtil, MenuUtil } from '@/utils';
import { mapActions, mapGetters } from 'vuex';

require('moment-jdateformatparser');
import DatePicker from '~c/DatePicker';
import ToastGrid from '~c/ToastGrid';
import SDLPagination from '~~c/control/pagination/Pagination';
import SKPBreadcrumbs from '~vb/main/SKPBreadcrumbs';
import RequestManagerDetail from '~vb/eur/admin/RequestManagerDetail';

const searchUserInfo = bpNo => {
    let api = `${SDLUtil.API_URL}/basis/eur/getUserInfo.skp`;
    return axios.post(api, qs.stringify({ bpNo: bpNo }));
};

export default {
    name: 'requestManagerList',
    components: {
        'toast-grid': ToastGrid,
        'sdl-pagination': SDLPagination,
        'skp-breadcrumbs': SKPBreadcrumbs,
        'request-manager-detail': RequestManagerDetail,
    },
    computed: {
        ...mapGetters({
            corpCd: 'getCorpCd',
            loginRhq: 'getLoginRhq',
            loginNo: 'getLoginNo',
            menus: 'getMenus',
        }),
    },
    data() {
        return {
            pageTitle: '',
            mode: 'list',
            data: {},
            totalCount: 0,
            currentPage: 1,
            nRecordsPerPage: Number(localStorage.getItem('listRows')),
            gridKey: 0,
            gridId: this.$route.name + 'Grid',
            columns: [],
            gridData: [],
            options: {
                scrollY: true,
                scrollX: true,
                minBodyHeight: 80,
                bodyHeight: 450,
            },
            header: {
                height: 70,
                complexColumns: [],
            },
            country1: '',
            country2: '',
            country3: '',
            requestType: '',
            approvalStatus: '',
            requestName: '',
            countryList1: [],
            countryList2: [],
            countryList3: [],
            requestTypeList: [],
            approvalStatusList: [],
            requestList: [],
        };
    },
    methods: {
        onSearch(page) {
            this.currentPage = page;
            this.searchList();
        },
        getSearchParams() {
            let mFormat = moment().toMomentFormatString(localStorage.getItem('dateFormat') || 'MM.dd.yyyy');
            let startDate = this.rangePicker.getStartDate();
            let endDate = this.rangePicker.getEndDate();
            let searchFromDt = startDate ? moment(startDate).formatWithJDF(mFormat) : '';
            let searchToDt = endDate ? moment(endDate).formatWithJDF(mFormat) : '';

            let searchParams = {
                page: this.currentPage,
                loginNo: this.loginNo,
                country1: this.country1,
                country2: this.country2,
                country3: this.country3,
                requestType: this.requestType,
                approvalStatus: this.approvalStatus,
                requestName: this.requestName,
                searchFromDt: searchFromDt,
                searchToDt: searchToDt,
            };
            return searchParams;
        },
        async searchList(v) {
            SDLUtil.showLoadingBar(true);
            let searchParams = this.getSearchParams();

            return axios
                .post(`${SDLUtil.API_URL}/noauth/eur/getRequestList.skp`, qs.stringify(searchParams))
                .then(resp => {
                    SDLUtil.showLoadingBar(false);
                    this.requestList = resp.data.result.rowData;
                    for (const result of this.requestList) {
                        result.SELECT_MODEL_CODE = result.MODEL_CD;
                        if (!SDLUtil.isNull(result.NATION_NM)) {
                            result.SELECT_MODEL_CODE += '(' + result.NATION_NM + ')';
                        }
                    }
                    this.totalCount = resp.data.search.totalRecords;
                    this.gridKey++;
                })
                .catch(err => {
                    SDLUtil.showLoadingBar(false);
                    Vue.$log.error(err);
                    SDLUtil.errorAlert(err);
                });
        },
        async getCommonCodeList(v) {
            const codeResp = await api.getCommonCodeList(v, 'A');
            return codeResp;
        },
        async getCodeComboList(categoryVal, categoryCode) {
            const codeResp = await api.getComboList(categoryVal, categoryCode, this.loginNo);
            return codeResp;
        },
        getCountryList1() {
            this.getCodeComboList(this.loginNo, 'RHQ_AUTH_ACCESS_CD').then(data => {
                this.countryList1 = data;
            });
        },
        getCountryList2() {
            this.getCodeComboList(this.country1, 'SUB_AUTH_ACCESS_CD').then(data => {
                let country2 = this.country2;
                this.countryList2 = data;
                const idx = this.countryList2.findIndex(function(item) {
                    return item.code === country2;
                });
                if (0 > idx) {
                    if (0 < this.countryList2.length) {
                        this.country2 = this.countryList2[0].code;
                    } else {
                        this.country2 = '';
                    }
                }
            });
        },
        async getCountryList3() {
            SDLUtil.showLoadingBar(true);
            return axios
                .post(
                    `${SDLUtil.API_URL}/basis/eur/getNationList.skp`,
                    qs.stringify({
                        loginNo: this.loginNo,
                        corpCd: this.country2,
                        type: 'approval',
                    }),
                )
                .then(resp => {
                    SDLUtil.showLoadingBar(false);
                    let country3 = this.country3;
                    let codeList = [];
                    this.countryList3 = [];
                    for (const result of resp.data.result.rowData) {
                        const idx = this.countryList3.findIndex(function(item) {
                            return item.code === result.COUNTRY_CD;
                        });
                        if (0 > idx) {
                            this.countryList3.push({ code: result.COUNTRY_CD, codeName: result.COUNTRY_NM });
                            codeList.push(result.CODE);
                        }
                    }

                    codeList = Array.from(new Set(codeList));
                    if (1 === codeList.length && !SDLUtil.isNull(codeList[0])) {
                        this.approvalStatus = codeList[0];
                    }
                })
                .catch(err => {
                    SDLUtil.showLoadingBar(false);
                    Vue.$log.error(err);
                    SDLUtil.errorAlert(err);
                });
        },
        contentClick(e, rowData, grid) {
            searchUserInfo(rowData[e.rowKey].BP_NO)
                .then(resp => {
                    this.data = { ...rowData[e.rowKey], ...resp.data.result };
                    this.mode = 'view';
                })
                .catch(err => {
                    Vue.$log.error(err);
                    SDLUtil.errorAlert(err);
                });
        },
        getColumn() {
            let header = [];
            let column = [];

            header.push({
                header: SDLUtil.getMsgProp('FIELD.REQUEST.INFO'),
                name: 'mergeColumn1',
                childNames: ['CATE_MAIN_NM', 'CATE_SUB_NM', 'SELECT_MODEL_CODE'],
            });

            column.push({
                header: SDLUtil.getMsgProp('FIELD.GLOBAL.REQUEST.DATE'),
                name: 'REQ_DT',
                align: 'center',
                width: 110,
                sortable: false,
                className: 'cur_pointer',
            });
            column.push({
                header: SDLUtil.getMsgProp('FIELD.REQUEST.TYPE'),
                name: 'REQ_TYPE_NM',
                align: 'center',
                width: 150,
                sortable: false,
                className: 'cur_pointer',
            });
            column.push({
                header: SDLUtil.getMsgProp('FIELD.BP.NUMBER'),
                name: 'BP_NO',
                width: 110,
                align: 'center',
                sortable: false,
                className: 'cur_pointer',
            });
            column.push({
                header: SDLUtil.getMsgProp('FIELD.GLOBAL.SUBSIDIARY'),
                name: 'RHQ_NM',
                width: 110,
                align: 'center',
                sortable: false,
                className: 'cur_pointer',
            });
            column.push({
                header: SDLUtil.getMsgProp('FIELD.COUNTRY.NAME'),
                name: 'COUNTRY_NM',
                align: 'center',
                width: 110,
                sortable: false,
                className: 'cur_pointer',
            });
            column.push({
                header: SDLUtil.getMsgProp('FIELD.MAJOR.PRODUCT.CATEGORY'),
                name: 'CATE_MAIN_NM',
                align: 'center',
                width: 180,
                sortable: false,
                className: 'cur_pointer',
            });
            column.push({
                header: SDLUtil.getMsgProp('FIELD.SUB.PRODUCT.CATEGORY'),
                name: 'CATE_SUB_NM',
                align: 'center',
                width: 180,
                sortable: false,
                className: 'cur_pointer',
            });
            column.push({
                header: SDLUtil.getMsgProp('FIELD.GLOBAL.MODEL.CODE'),
                name: 'SELECT_MODEL_CODE',
                align: 'left',
                width: 250,
                sortable: false,
                className: 'cur_pointer',
            });
            column.push({
                header: SDLUtil.getMsgProp('FIELD.APPROVAL.STATUS'),
                name: 'STATUS_NM',
                align: 'center',
                width: 120,
                sortable: false,
                className: 'cur_pointer',
            });
            column.push({
                header: SDLUtil.getMsgProp('FIELD.1ST.APPROVAL.DATE'),
                name: 'APR_FRST_DT',
                align: 'center',
                width: 130,
                sortable: false,
                className: 'cur_pointer',
            });
            column.push({
                header: SDLUtil.getMsgProp('FIELD.2ND.APPROVAL.DATE'),
                name: 'APR_SCND_DT',
                align: 'center',
                width: 130,
                sortable: false,
                className: 'cur_pointer',
            });

            this.header.complexColumns = header;
            this.columns = column;
            this.gridKey++;
        },
        goListBack(data) {
            this.mode = 'list';
            this.onSearch(1);
        },
    },
    created() {
        EventBus.$on('goRequestListBack', this.goListBack);
    },
    beforeDestroy() {
        EventBus.$off('goRequestListBack');
    },
    mounted() {
        let main = true;
        for (const menus of this.menus) {
            if (!main) break;
            for (const menu of menus.subMenu) {
                if (!main) break;
                for (const subMenu of menu.subMenu) {
                    if (
                        !SDLUtil.isNull(subMenu.connUrl) &&
                        '/erp/requestManagerList' === subMenu.connUrl.replace('.skp', '')
                    ) {
                        store.commit('PARAMS', { menuId: subMenu.menuId, creationYn: subMenu.creationYn });
                        main = false;
                        break;
                    }
                }
            }
        }

        if (main) this.$router.push({ path: `${SDLUtil.WEB_CONTEXT_PATH}/main` });

        this.rangePicker = DatePicker.createRangeWithOpener(
            'fr-picker-container',
            'frDate',
            'icoFrDate',
            'to-picker-container',
            'toDate',
            'icoToDate',
            { type: 'date', locale: 'en', showToday: false },
            new moment().add(-1, 'month').toDate(),
            new moment().toDate(),
        );

        this.$nextTick(() => {
            this.country1 = this.loginRhq;
            this.country2 = this.corpCd;

            this.getCountryList1();
            this.getCountryList2();
            this.getCountryList3();

            this.getCommonCodeList('REQUEST_TYPE').then(data => {
                this.requestTypeList = data;
            });
            this.getCommonCodeList('APPR_STATUS').then(data => {
                this.approvalStatusList = data;
            });
            this.getColumn();
        });
    },
};
</script>

<style>
.tui-datepicker {
    z-index: 9999;
    border: 1px solid #aaa;
    background-color: white;
    position: absolute;
}
</style>



// WEBPACK FOOTER //
// src/skpComponents/view/basis/eur/admin/RequestManagerList.vue